import React from 'react';
import TextInputFormik, { TextInputFormikProps } from './TextInputFormik';

type Props = Omit<TextInputFormikProps, 'leftIcon' | 'allowedRegex'> & {
  showIcon?: boolean;
};

const MONEY_AMOUNT_REGEX = /^[\d]+(\.([\d]){0,2})?$/;

const TRANSFORM_REPLACE_REGEX = /[$,\s]/g;

/**
 * A text input component for entering money values, such as "0.99" and "100.50".
 */
const MoneyInputFormik: React.FC<Props> = ({ showIcon = true, ...props }) => {
  const transformValue = (value: string): string => {
    // Special handling for case where users may be copy + pasting a money value
    // into this input. That value might contain a dollar sign, comma(s), and/or
    // spaces but we still want to let them paste it without issue, so we strip
    // the invalid characters here to allow the value to pass the allowedRegex test.
    return value.replace(TRANSFORM_REPLACE_REGEX, '');
  };

  return (
    <TextInputFormik
      leftIcon={showIcon ? 'dollar' : undefined}
      allowedRegex={MONEY_AMOUNT_REGEX}
      transformValue={transformValue}
      {...props}
    />
  );
};

export default MoneyInputFormik;
